import { render, staticRenderFns } from "./BlacklistReasonEditModal.vue?vue&type=template&id=719622f2&"
import script from "./BlacklistReasonEditModal.vue?vue&type=script&lang=js&"
export * from "./BlacklistReasonEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports